import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LuMenu, LuX } from "react-icons/lu";
import { Brand, Btn } from "./Ui";

export default function PublicNav() {
  const { pathname } = useLocation();
  const links = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Career Insights" },
    { to: "/contact", label: "Contact" },
  ];
  /* phone: the brand + 3 links + 2 buttons cannot share a 390px bar, so the
     links and the secondary action collapse into a menu */
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header className="pubnav">
      <div className="wrap pubnav-inner">
        <Brand />
        <nav className="pubnav-links grow">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className={`pubnav-link${pathname === l.to ? " on" : ""}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="row pubnav-actions">
          <Btn variant="quiet" to="/login">
            Sign in
          </Btn>
          <Btn to="/page-register">Get started free</Btn>
        </div>
        <button
          type="button"
          className="pubnav-burger"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          {menuOpen ? <LuX size={20} /> : <LuMenu size={20} />}
        </button>
      </div>

      {menuOpen ? (
        <div className="pubnav-sheet">
          <div className="wrap stack-2">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`pubnav-sheet-link${pathname === l.to ? " on" : ""}`}
              >
                {l.label}
              </Link>
            ))}
            <Btn variant="soft" to="/login" full>
              Sign in
            </Btn>
            <Btn to="/page-register" full>
              Get started free
            </Btn>
          </div>
        </div>
      ) : null}
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="foot">
      <div className="wrap foot-inner">
        <div className="stack-2" style={{ maxWidth: 300 }}>
          <Brand />
          <p className="t-xs">
            AI-powered job search: matched roles, resume tailoring, and interview practice in one place.
          </p>
          <p className="t-xs">
            © {new Date().getFullYear()} CareerSavvy. All rights reserved.
          </p>
        </div>
        <div className="row" style={{ gap: 26, alignItems: "flex-start", flexWrap: "wrap" }}>
          <div className="stack-2">
            <span className="t-label">Product</span>
            <Link to="/page-register">Get started</Link>
            <Link to="/login">Sign in</Link>
            <Link to="/blog" target="_blank" rel="noopener noreferrer">Career Insights</Link>
          </div>
          <div className="stack-2">
            <span className="t-label">Features</span>
            <Link to="/ai-resume-builder" target="_blank" rel="noopener noreferrer">AI resume builder</Link>
            <Link to="/ai-job-search" target="_blank" rel="noopener noreferrer">AI job search</Link>
            <Link to="/mock-interview-practice" target="_blank" rel="noopener noreferrer">Mock interviews</Link>
            <Link to="/interview-preparation" target="_blank" rel="noopener noreferrer">Interview prep</Link>
          </div>
          <div className="stack-2">
            <span className="t-label">Legal</span>
            <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
            <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</Link>
            <Link to="/cookies" target="_blank" rel="noopener noreferrer">Cookie Policy</Link>
            <Link to="/gdpr" target="_blank" rel="noopener noreferrer">GDPR</Link>
          </div>
          <div className="stack-2">
            <span className="t-label">Company</span>
            <Link to="/contact" target="_blank" rel="noopener noreferrer">Contact us</Link>
            <a href="mailto:support@careersavvy.ai">Email support</a>
            <a href="https://careersavvy.ai" target="_blank" rel="noreferrer">
              careersavvy.ai
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
